import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { NotfoundComponent } from './components/notfound/notfound.component';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authGuard } from './core/guard/auth.guard';
import { adminGuard } from './core/guard/admin.guard';
import { storeStaffGuard } from './core/guard/store-staff.guard';
import { superAdminGuard } from './core/guard/super-admin.guard';
import { ChangePasswordComponent } from './components/auth/change-password/change-password.component';
import { ProfileComponent } from './components/auth/profile/profile.component';
import { SettingsComponent } from './components/settings/settings.component';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          canActivate: [authGuard],
          children: [
            {
              path: '',
              loadChildren: () => import('./components/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
            },
            {
              path: 'user',
              loadChildren: () => import('./components/user/user.routes').then((m) => m.USER_ROUTES),
              canActivate: [adminGuard],
            },
            {
              path: 'customer',
              loadChildren: () => import('./components/customer/customer.routes').then((m) => m.CUSTOMER_ROUTES),
              canActivate: [adminGuard],
            },
            {
              path: 'dish',
              loadChildren: () => import('./components/dish/dish.routes').then((m) => m.DISH_ROUTES),
            },
            {
              path: 'category',
              loadChildren: () => import('./components/category/category.routes').then((m) => m.CATEGORY_ROUTES),
            },
            {
              path: 'store',
              loadChildren: () => import('./components/store/store.routes').then((m) => m.STORE_ROUTES),
            },
            {
              path: 'inventory-item',
              loadChildren: () =>
                import('./components/inventory-item/inventory-item.routes').then((m) => m.INVENTORY_ITEM_ROUTES),
            },
            {
              path: 'store-inventory',
              loadChildren: () =>
                import('./components/store-inventory/store-inventory.routes').then((m) => m.STORE_INVENTORY_ROUTES),
            },
            {
              path: 'menu-item',
              loadChildren: () => import('./components/menu-item/menu-item.routes').then((m) => m.MENU_ITEM_ROUTES),
            },
            {
              path: 'popular-menu-item',
              loadChildren: () =>
                import('./components/popular-menu-item/popular-menu-item.routes').then(
                  (m) => m.POPULAR_MENU_ITEM_ROUTES,
                ),
              canActivate: [superAdminGuard],
            },
            {
              path: 'side-line',
              loadChildren: () => import('./components/side-line/side-line.routes').then((m) => m.SIDE_LINE_ROUTES),
              canActivate: [superAdminGuard],
            },
            {
              path: 'promo-code',
              loadChildren: () =>
                import('./components/promo-code/promo-code.routes').then((m) => m.PROMO_CODE_ROUTES),
            },
            {
              path: 'loyalty-program',
              loadChildren: () =>
                import('./components/loyalty-program/loyalty-program.routes').then((m) => m.LOYALTY_PROGRAM_ROUTES),
            },
            {
              path: 'loyalty-points-ledger',
              loadChildren: () =>
                import('./components/loyalty-points-ledger/loyalty-points-ledger.routes').then(
                  (m) => m.LOYALTY_POINTS_LEDGER_ROUTES,
                ),
              canActivate: [storeStaffGuard],
            },
            {
              path: 'order',
              loadChildren: () => import('./components/order/order.routes').then((m) => m.ORDER_ROUTES),
            },
            {
              path: 'notifications',
              loadChildren: () =>
                import('./components/notification/notification.routes').then((m) => m.NOTIFICATION_ROUTES),
            },
            {
              path: 'utilities',
              loadChildren: () => import('./components/utilities/utilities.routes').then((m) => m.UTILITIES_ROUTES),
            },
            {
              path: 'blocks',
              loadChildren: () =>
                import('./components/primeblocks/primeblocks.routes').then((m) => m.PRIME_BLOCKS_ROUTES),
            },
            { path: 'profile', component: ProfileComponent },
            { path: 'change-password', component: ChangePasswordComponent },
            { path: 'settings', component: SettingsComponent },
          ],
        },
        {
          path: 'auth',
          loadChildren: () => import('./components/auth/auth.routes').then((m) => m.AUTH_ROUTES),
          canActivate: [authGuard],
        },
        { path: 'notfound', component: NotfoundComponent },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
